import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  viewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatListOption } from '@angular/material/list';
import { ReplaySubject, fromEvent } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  finalize,
  map,
  takeUntil,
  tap,
} from 'rxjs/operators';

import { ConsoleService } from 'src/app/core/services/console.service';
import { selectionListRequiredValidator } from '../selection-list-validator';
import { CommonService } from './../../../../../core/services/common.service';
import { BaseSelectionListProperties } from './../base-selection-list-properties.component';

@Component({
  selector: 'app-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss'],
  standalone: false,
})
export class SelectionListComponent
  extends BaseSelectionListProperties
  implements OnInit
{
  //#region Properties
  readonly searchInput = viewChild<ElementRef>('searchInput');
  @Input() heightClass: string;
  @Input() hasCustomClass: boolean = false;
  @Input() isShowSearch: boolean = true;
  @Input() isMultipleSelect: boolean = true;

  public filterControl: FormControl = new FormControl();
  public filteredItems: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  totalSelectedCount: number = 0;
  filteredItemsCount: number = 0;

  isSelectAll: boolean = false;

  searchedItems: any[];
  baseValues: any[];
  //#endregion

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.baseValues = Object.assign([], this.values);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && this.items) {
      if (this.items.length && this.customSortArray?.length) {
        this.sortArrayByArray(this.customSortArray);
      }

      if (this.items.length && this.values?.length) this.sortArrayByArray();

      this.initConfig();
    }

    if (changes['values'] && this.values?.length) this.getSelectedItems();

    if (changes['values'] && this.values?.length == 0) {
      this.emptySelected();
    }

    if (changes['isRequired'] && this.isRequired) {
      this.input_form.controls[this.input_formControlName].setValidators(
        selectionListRequiredValidator(this.values)
      );
      this.input_form.controls[
        this.input_formControlName
      ].updateValueAndValidity();
    }

    if (changes?.maxShowItemInDisplay && this.maxShowItemInDisplay == 0) {
      if (this.isSmallSize) this.maxShowItemInDisplay = 5;
      else this.maxShowItemInDisplay = 24;
    }
  }

  // get items and config search items
  initConfig() {
    this.onSearch();
    this.getSelectedItems();
  }

  getSelectedItems() {
    //select item
    this.items.forEach((item) => {
      item.selected = this.values?.includes(item[this.optionValue]);
      if (!this.isDisableSelectedItem)
        item.selected && this.isRoleOrganizationForm
          ? (item.disabled = true)
          : false;
    });
    if (this.isDisableSelectedItem)
      this.items.forEach((item) => {
        item.selected = this.baseValues?.includes(item[this.optionValue]);
        item.selected ? (item.disabled = true) : false;
      });
    //selected items count
    this.totalSelectedCount = this.getSelectedItemsCount(this.items);
    this.isSelectedAll();

    this.emit();
  }

  emptySelected() {
    this.getSelectedItems();
    // this.isSelectedAll();
  }

  onSearch() {
    if (!this.items) return;

    this.initFilteredItems();

    fromEvent(this.searchInput()?.nativeElement, 'keyup')
      .pipe(
        debounceTime(300),
        map((event) => event as KeyboardEvent),
        map((event) => (event.target as HTMLInputElement).value),
        map((searchText) => (searchText as string).toLowerCase().trim()),
        distinctUntilChanged(),
        tap(() => (this.loading = true)),
        finalize(() => {
          this.loading = false;
        }),
        takeUntil(this.onDestroy$),
        map((searchText) => {
          if (!this.items) return [];

          //show all items
          if (!searchText) this.items.slice(0, this.items.length);

          // filter by search
          return this.items.filter(
            (item) =>
              item[this.optionTitle]?.toLowerCase().indexOf(searchText) > -1
          );
        })
      )
      .subscribe((filteredItems) => {
        this.loading = false;
        if (filteredItems != this.searchedItems) this.isSelectAll = false;
        this.searchedItems = filteredItems;
        this.filteredItems.next(filteredItems);
        this.filteredItemsCount = filteredItems?.length;
        this.isSelectedAll();
      });
  }

  initFilteredItems() {
    this.filteredItems.next(this.items?.slice(0, this.items.length));
    this.filteredItemsCount = this.items.length;
  }

  sortArrayByArray(customArray?: any) {
    this.items = CommonService.sortArrayByArray(
      this.items,
      customArray || this.values,
      this.sortKey
    );
  }

  //#region select operation

  isChecked(id): boolean {
    const exists = this.values?.some((item) => item == id);
    return exists;
  }

  onChangeSelectionList(event: MatListOption, item?) {
    if (!this.values) this.values = [];

    if (event.selected) this.values?.push(event.value);
    else {
      const index = this.values.findIndex((item) => item == event.value);
      if (index != -1) this.values.splice(index, 1);
    }
    this.onClickOption(item);
    this.onSelectItem(event.value);
  }

  onClickOption(event) {
    ConsoleService.info('event', event);
    this.output_clickedOption.emit(event);
  }

  selectAll() {
    if (!this.values) this.values = [];

    if (this.searchedItems) {
      if (!this.isSelectAll) {
        //حذف آیتم هایی که با سرچ نمایش داده میشوند
        this.values = this.values.filter((item) => {
          return !this.searchedItems.find((searchedItem) => {
            return item === searchedItem[this.optionValue];
          });
        });
      }

      this.searchedItems.forEach((item) => {
        item.selected = this.isSelectAll;
        if (item.selected) this.values.push(item[this.optionValue]);
      });

      //گرفتن دسترسی هایی که انتخاب نشده اند
      var notSelectedClaims = this.items.filter((item) => {
        return !this.searchedItems.find((searchedItem) => {
          return item[this.optionValue] === searchedItem[this.optionValue];
        });
      });
      //اضافه کردن آرایه ی جدید با وضعیت جدید به دسترسی های قبلی که انتخاب نشده اند
      this.items = notSelectedClaims.concat(this.searchedItems);
    } else {
      this.values = [];
      this.items.forEach((item) => {
        item.selected = this.isSelectAll;
        if (item.selected) this.values.push(item[this.optionValue]);
      });
    }
    // this.initFilteredItems();

    this.totalSelectedCount = this.getSelectedItemsCount(this.items);

    this.emit();
  }

  isSelectedAll() {
    let allSelected = false;
    if (this.searchedItems)
      allSelected = this.searchedItems.every((items) => items.selected == true);
    // is select all
    else allSelected = this.items.every((item) => item.selected === true);
    if (allSelected) this.isSelectAll = true;
    else this.isSelectAll = false;
  }

  onSelectItem(event) {
    let index = this.items.findIndex(
      (item) => item[this.optionValue] === event
    );
    if (index === -1) return;
    this.items[index].selected = !this.items[index].selected;

    this.isSelectedAll();

    this.items[index].disabled = false;
    this.totalSelectedCount = this.getSelectedItemsCount(this.items);
    this.emit();
  }

  getSelectedItemsCount(items): number {
    const count = items.filter((item) => {
      if (item.selected) return true;
      return false;
    }).length;

    return count;
  }

  //#endregion

  emit() {
    let selectedItems = this.items?.filter((item) =>
      this.values?.includes(item[this.optionValue])
    );

    if (this.values)
      this.values = this.values.filter(
        (value, index) => this.values.indexOf(value) === index
      );

    this.output_items.emit(selectedItems);
    this.output_values.emit(this.values);
  }

  onRemoveAll() {
    this.values = [];
    this.items = this.items.map((item) => (item.selected = false));
    this.totalSelectedCount = this.getSelectedItemsCount(this.items);
    this.emit();
  }

  unSubs(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnDestroy(): void {
    this.unSubs();
  }
}
